@layer reset, default, type.signature, type.wordmark, variant.colour, variant.white, desktop, highcontrast;

@layer reset {
  :host {
    display: block;
    width: fit-content;
  }
}

@layer default {
  :host {
    .gcds-signature {
      display: flex;
    }

    svg {
      display: block;
      max-width: 100%;

      .fip_flag {
        fill: var(--gcds-signature-color-flag);
      }
    }
  }
}

@layer type.signature {
  :host(:not([type='wordmark'])) svg {
    height: var(--gcds-signature-signature-height);
  }
}

@layer type.wordmark {
  :host([type='wordmark']) svg {
    height: var(--gcds-signature-wordmark-height);
    width: auto;
  }
}

@layer variant.colour {
  :host(:not([variant='white'])) svg {
    .fip_text {
      fill: var(--gcds-signature-color-text);
    }
  }
}

@layer variant.white {
  :host([variant='white']) svg {
    :is(.fip_text) {
      fill: var(--gcds-signature-white-default);
    }
  }
}

/* Note: viewport specific style decision */
@layer desktop {
  :host(:not([type='wordmark'])) svg {
    @media screen and (width >= 64em) {
      height: var(--gcds-signature-signature-height-desktop);
    }
  }
}

@layer highcontrast {
  :host svg .fip_text {
    @media (prefers-color-scheme: light) {
      fill: var(--gcds-signature-color-text);
    }
    @media (prefers-color-scheme: dark) {
      fill: var(--gcds-signature-white-default);
    }
  }
}
